import {BaseSearchableService} from "./Core/BaseSearchableService";

class EcoregionService extends BaseSearchableService {
    get Url() { return super.Url + "/ecoregions"; }
    get ModelName() { return "Ecoregion"; }
    get PrimaryKeyProperty() { return "ecoregionId"; }

    Get() {
        return this.SendRequest(BaseSearchableService.GET, this.request);
    }
}

export const service = new EcoregionService();

